/**
 * Created by lihanying on 2017/6/20.
 */
import thunk from 'redux-thunk'
import { createLogger } from 'redux-logger'
import { createStore, applyMiddleware, compose } from 'redux'

const loggerMiddleware = createLogger()

const middleware = [thunk]
if (process.env.NODE_ENV !== 'production') {
  // middleware.push(loggerMiddleware)
}

const enhanceStore = compose(
  applyMiddleware(...middleware)
)(createStore)

export default enhanceStore


// WEBPACK FOOTER //
// ./src/Store.js